<div class="adc-layer-settings-header flex" space-between>
    <div>Knowledge Hub System Settings</div>
    <button mat-button mat-dialog-close>
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="groups-container">
        <div class="group">
            <div class="group-content">
                <div class="row group-content-row">
                    <div class="col-7 group-content__title-wrapper wrapper-padding">
                        <mat-label class="group-title">Select All</mat-label>
                    </div>
                    <div class="col-1">
                        <oct-check-box (change)="onCheckAll($event)" [checkColor]="'all'" [checked]="showAll"
                                       checkBoxName="selectAll-Layers"></oct-check-box>
                    </div>
                </div>
            </div>
        </div>

        <div *ngFor="let groupName of groupsNames" class="group">
            <div class="row">
                <div class="col-12 group-content__title-wrapper">
                    <mat-label *ngIf="!!(displayData | filterArrByKeyValue : groupBy : groupName).length"
                               [ngClass]="groupName.toLowerCase()"
                               class="group-label">{{ groupName }}
                    </mat-label>
                    <mat-label *ngIf="groupsSubNames[groupName]" class="group-content__sub-title">
                        ({{ groupsSubNames[groupName].toUpperCase() }})
                    </mat-label>
                </div>
                <div [ngClass]="groupName.toLowerCase()" class="col-12 group-content__title-underline"></div>
            </div>
            <div *ngFor="let groupItem of displayData | filterArrByKeyValue : groupBy : groupName"
                 class="flex group-content">
                <div class="row group-content-row">
                    <div class="col-7 group-content__title-wrapper wrapper-padding">
                        <mat-label
                                class="group-title">{{ groupItem.displayName == 'Data Catalog' ? 'Knowledge Hub' : groupItem.displayName }}</mat-label>
                    </div>
                    <div class="col-1">
                        <oct-check-box (change)="onCheckAllGroupItems(groupItem, $event)"
                                       [checkColor]="groupItem.items[0].class"
                                       [checked]="groupItem.checked"
                                       checkBoxName="selectAll-GroupItems"></oct-check-box>
                    </div>
                    <div class="col-4 group-content__items-wrapper">
                        <ng-container *ngFor="let item of groupItem.items">
                            <mat-icon (click)="onItemCheck(item, groupItem)"
                                      [ngClass]="{disabled: !item.checked}"
                                      class="adc-settings-icon {{item.name}} {{item.class}}"
                                      matTooltip="{{item.displayName == 'Data Catalog'? 'Knowledge Hub'.toUpperCase() : item.displayName?.toUpperCase()}}"
                                      svgIcon="{{moduleLayerIconMapping[item.key] || (item.checked ? item.iconEnable : item.iconDisable)}}">
                            </mat-icon>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="footer-inner">
        <oct-round-button (clicked)="onApplyFilter()" class="adc-filter-apply-btn" fontSize="1.2rem"
                          id="Apply_Layer_Settings"
                          matTooltip="Apply Search Filter" text="Apply"></oct-round-button>
    </div>
</mat-dialog-actions>
